import { unlinkEhrUserAccount } from '@/pages/api/scribeOpenAPI';
import { toast } from '@heidi/design-system/toast';
import { useMutation } from '@tanstack/react-query';

export function useMutateUnlinkWidgetAccount() {
  return useMutation({
    retry: 0,
    mutationKey: ['unlinkEhrUserAccount'],
    mutationFn: async () => {
      return unlinkEhrUserAccount();
    },
    onError: () => {
      toast({
        tone: 'destructive',
        title: 'Error',
        description: 'Something went wrong, refresh the page to try again.',
      });
    },
  });
}
